<template>
	<div class="form-request-viewer">
		<header class="form-request-toolbar">
			<div class="form-identity">
				<span class="form-mark" aria-hidden="true">
					<portal-icon name="file-text" :size="19"></portal-icon>
				</span>
				<div class="form-title">
					<h1>{{ request.name }}</h1>
					<span>{{ $t('forms.submissions.incomplete') }}</span>
				</div>
			</div>

			<button
				type="button"
				class="round-action"
				:aria-label="$t('global.close')"
				:title="$t('global.close')"
				@click="handleClose"
			>
				<portal-icon name="x" :size="19"></portal-icon>
			</button>
		</header>

		<main class="form-request-body show-scrollbar">
      <discovery-form :request-token="token" v-if="token" @result="$emit('result',$event)"></discovery-form>
		</main>
	</div>
</template>

<script>
  import DiscoveryForm from '@/modules/forms/DiscoveryForm';
  export default {
		name: 'FormRequestViewer',

		props: ['request'],

		components: { DiscoveryForm },

		data: function() {
			return {

			};
		},

		mounted() {

		},

		beforeDestroy() {
		},

		methods: {
			handleClose: function() {
				this.$emit('result');
			},
		},

		computed: {
      token: function(){
        if (this.request.requestToken || this.request.token) {
          return this.request.requestToken || this.request.token;
        }

        if (!this.request.url) {
          return null;
        }

        try {
          const parsedUrl = new URL(this.request.url, window.location.origin);
          return parsedUrl.searchParams.get('token');
        } catch (err) {
          return null;
        }
      }
		},
	};
</script>

<style scoped lang="scss">
  .form-request-viewer {
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background: var(--portal-canvas);
		color: var(--portal-text);
	}

	.form-request-toolbar {
		min-height: 68px;
		flex: 0 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		padding: 10px 14px 10px 18px;
		border-bottom: 1px solid var(--portal-border);
		background: var(--portal-surface);
	}

	.form-identity {
		min-width: 0;
		display: flex;
		align-items: center;
		gap: 11px;
	}

	.form-mark {
		width: 38px;
		height: 38px;
		flex: 0 0 38px;
		display: grid;
		place-items: center;
		border-radius: 12px;
		background: color-mix(in srgb, var(--v-primary-base) 10%, var(--portal-surface));
		color: var(--v-primary-base);
	}

	.form-title {
		min-width: 0;
		display: grid;
		gap: 2px;
	}

	.form-title h1 {
		margin: 0;
		overflow: hidden;
		color: var(--portal-text);
		font-size: 17px;
		font-weight: 680;
		line-height: 1.25;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.form-title span {
		color: var(--v-alert-base);
		font-size: 12px;
		font-weight: 620;
	}

	.round-action {
		width: 38px;
		height: 38px;
		flex: 0 0 38px;
		display: grid;
		place-items: center;
		padding: 0;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-button-radius, 50%);
		background: var(--portal-surface);
		color: var(--portal-muted);
		cursor: pointer;
		transition: border-color 140ms ease, color 140ms ease, background-color 140ms ease;
	}

	.round-action:hover,
	.round-action:focus-visible {
		outline: 0;
		border-color: color-mix(in srgb, var(--portal-muted) 55%, var(--portal-border));
		background: var(--v-gray_20-base);
		color: var(--portal-text);
	}

	.form-request-body {
		min-height: 0;
		flex: 1;
		overflow-y: auto;
		background: var(--portal-surface);
	}

	@media (max-width: 599px) {
		.form-request-toolbar {
			min-height: 62px;
			padding-left: 12px;
		}

		.form-mark {
			width: 34px;
			height: 34px;
			flex-basis: 34px;
		}
	}
</style>
